<template>
  <div class="width_auto">
    <div class="type-nav-box" @mouseenter="showPanel(categories)" @mouseleave="hidePanel">
      <!-- 左侧分类触发按钮 -->
       <div>
         <div class="category-trigger mr_20">
           商品分类
         </div>
       </div>
      <!-- 分类面板 -->
      <transition name="slide">
        <!-- isExpanded -->
        <div v-show="isExpanded" class="category-panel">
          <!-- 左侧一级分类 -->
          <ul class="primary-category-list">
            <li
              v-for="category in categories"
              :key="category.classifyId"
              class="primary-category-item"
              :class="{ 'active-secondary': category.classifyId == activeSecondaryCategory }"
              @mouseenter="showSubCategory(category)"
              @mouseleave="hideSubCategory"
            >
              <span @click="jumpCategory(category)">
                {{ category.classifyName }}
              </span>
            </li>
          </ul>

          <!-- 右侧多级分类面板 -->
          <div class="subcategory-panel" v-if="currentCategory">
            <!-- 二级分类 -->
            <ul class="secondary-category-list">
              <li
                v-for="sub in currentCategory.childs"
                :key="sub.classifyId"
                class="secondary-category-item"
              >
              <!-- {{ sub.classifyId == activeSecondaryCategory.classifyId }} -->
              <div class="flex flex_a_c">
                <div class="secondary-category-list-title ell cursor_p" @click="jumpCategory(sub)">
                  {{ sub.classifyName }}
                </div>
                <i class="el-icon-arrow-right mr_10"></i>
                <div class="flex flex_w">
                  <div class="mr_10 color_666 cursor_p" v-for="(subSub,subSubk) in sub.childs" :key="subSubk" @click="jumpCategory(subSub)">
                    <span>{{ subSub.classifyName }}</span>
                  </div>
                </div>
              </div>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
    <div class="fontSize_16 flex flex_a_c display_ib">
      <span class="plr_10 cursor_p color_584dff fontW_b">推荐</span>
      <span class="plr_10 cursor_p" v-for="(i,k) in categories.slice(0, 10)" :key="k" @click="jumpCategory(i)">
        {{ i.classifyName }}
      </span>
    </div>
  </div>
</template>

<script>
// import categoryData from '@/util/categoryData'
import {
  getCategory
} from '@/api/nav.js'

export default {
  name: 'TypeNav',
  data () {
    return {
      categories: [],
      isExpanded: false,
      currentCategory: null,
      activeSecondaryCategory: null, // 新增：记录当前激活的二级分类
      recommendData: [
        {
          id: 0,
          name: '3折疯抢'
        }, {
          id: 0,
          name: '天天低价'
        }, {
          id: 0,
          name: '奢品'
        }, {
          id: 0,
          name: '女装'
        }, {
          id: 0,
          name: '食品'
        },
      ]
    }
  },
  mounted () {
    this.getCategoryData()
  },
  methods: {
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      if (res.code === '200') {
        this.categories = res.data
        this.categories.forEach(element => {
          element.childs = []
          let obj = {
            classifyId: element.classifyId,
          }
          getCategory(obj).then(res2 => {
            element.childs = res2.data.data
          })
        })
        // console.log(this.categories, 'this.categories')
      }
    },
    showPanel (data) {
      this.currentCategory = data[0]
      this.activeSecondaryCategory = data[0].classifyId
      this.isExpanded = true
    },
    hidePanel () {
      this.isExpanded = false
      this.currentCategory = null
    },
    showSubCategory (category) {
      this.activeSecondaryCategory = category.classifyId // 记录当前激活的二级分类
      this.currentCategory = category
    },
    hideSubCategory () {
      // 可选：如果你希望鼠标移出子分类时不关闭右侧面板，可以注释掉这行
      // this.currentCategory = null
    },
    handleItemClick (item) {
      // console.log('Selected Item:', item)
      // 这里可以添加跳转逻辑或全局事件
    },
        // 跳转到类别主页
    jumpCategory (item) {
      this.$router.push({
        name: 'category',
        query: {
          classifyData: JSON.stringify(item)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.type-nav-box {
  position: relative;
  display: inline-block;
}

.category-trigger {
  width: 156px;
  height: 43px;
  cursor: pointer;
  padding: 10px 20px;
  background-color: rgba(88, 77, 255, 1);
  color: white;
  text-align: center;
  font-weight: bold;
  user-select: none;
}

.category-panel {
  position: absolute;
  top: 43px;
  left: 0;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  width: 990px;
  max-height: 600px;
  overflow-y: auto;
}

.primary-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 156px;
  background-color: rgba(88, 77, 255, 1);
  color: #fff;
}

.primary-category-item {
  height: 43px;
  line-height: 43px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  &.active-secondary {
    background-color: #fff !important; // 强制高亮为白色
    color: rgba(88, 77, 255, 1);
  }
  &:hover {
    background-color: #fff;
    color: rgba(88, 77, 255, 1);
  }
}

.secondary-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: calc(990px - 156px);
  padding: 16px 40px 16px 40px;
}

.secondary-category-item {
  line-height: 30px;
  box-sizing: border-box;

  &:hover {
    background-color: #f9f9f9;
  }
  .secondary-category-list-title{
    width: 72px;
    min-width: 72px;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

</style>



// WEBPACK FOOTER //
// src/components/base/TypeNav.vue